import { Button } from "@/components/ui/buttons/Button/Button";
import { Typography } from "@/components/ui/text/Typography/Typography";

import { Modal, type ModalProps } from "./Modal";

export type ActionModalProps = {
  heading: string;
  description: string;
  note?: string;
  isLoading?: boolean;
  primaryAction: {
    label: string;
    onPress: () => void;
  };
  secondaryAction?: {
    label: string;
    onPress: () => void;
  };
} & ModalProps;

export const ActionModal = ({
  heading,
  description,
  note,
  isLoading,
  primaryAction,
  secondaryAction,
  ...modalProps
}: ActionModalProps) => {
  return (
    <Modal
      {...modalProps}
      title={heading}
    >
      <Typography
        size="body-3"
        className="dm:px-2 dm:pt-3 text-center"
      >
        {description}
      </Typography>
      {note && (
        <Typography
          size="body-4"
          variant="default-italic"
          className="dm:px-2 dm:pt-3 text-center text-text-inverted-secondary"
        >
          {note}
        </Typography>
      )}

      <div className="flex dm:w-svw t:w-full flex-row flex-wrap justify-center gap-4 dm:px-2 pt-1 dm:pb-4">
        <Button
          variant="outlined"
          size="small"
          onPress={primaryAction.onPress}
          width="auto"
          className="min-w-20"
          isLoading={isLoading}
        >
          {primaryAction.label}
        </Button>

        {secondaryAction && (
          <Button
            variant="outlined"
            size="small"
            onPress={secondaryAction?.onPress}
            width="auto"
            className="min-w-20"
          >
            {secondaryAction?.label}
          </Button>
        )}
      </div>
    </Modal>
  );
};
